export default __webpack_public_path__ + "static/media/gallery-8.2a68fa5f.jpg";